// src/features/profile/Sponsoring/components/PaymentDialog.tsx

import React, { FC } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { InlineIcon } from "@iconify/react";
import { TSubscriptionPlan } from "@/features/profile/types/types";

type PaymentDialogProps = {
  open: boolean;
  offer: TSubscriptionPlan | null;
  onClose: () => void;
  onPayByCard: () => void;
  onPayByPaypal: () => void;
  getPriceByGender: (offer: TSubscriptionPlan) => number;
};

/**
 * Fenêtre modale proposant le choix du mode de paiement
 */
const PaymentDialog: FC<PaymentDialogProps> = ({
  open,
  offer,
  onClose,
  onPayByCard,
  onPayByPaypal,
  getPriceByGender,
}) => {
  if (!offer) return null; // Pas d’offre sélectionnée => ne rien afficher

  const price = getPriceByGender(offer);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="payment-dialog-title"
    >
      <DialogTitle
        id="payment-dialog-title"
        sx={{ color: "var(--ui-dark)", fontWeight: "bold" }}
      >
        Paiement de l'offre
      </DialogTitle>

      <DialogContent>
        <DialogContentText sx={{ color: "var(--ui-medium)" }}>
          <Typography variant="subtitle1" fontWeight="bold">
            {offer.name}
          </Typography>
          <Typography variant="body2" mb={2}>
            {offer.description}
          </Typography>

          <Typography variant="body1">
            Montant à payer :{" "}
            <b>
              {price}
              {offer.currency === "EUR" && " €"}
              {offer.currency === "USD" && " $"}
            </b>
          </Typography>

          <Typography variant="body1">
            Durée : <b>{offer.duration}</b>
          </Typography>

          <Typography variant="body2" mt={2}>
            Veuillez sélectionner votre mode de paiement :
          </Typography>
        </DialogContentText>
      </DialogContent>

      <DialogActions
        sx={{
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          pb: 3,
        }}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={onPayByCard}
          startIcon={<InlineIcon icon="mdi:credit-card-outline" />}
          sx={{ textTransform: "none", fontWeight: 500 }}
        >
          Payer par carte bancaire&nbsp;&nbsp;
          <img
            src={require("@/assets/images/png/pay-by-cb.png")}
            alt="pay-by-cb"
            width={50}
            style={{ verticalAlign: "middle" }}
          />
        </Button>

        <Button
          variant="contained"
          color="tertiary"
          onClick={onPayByPaypal}
          startIcon={<InlineIcon icon="logos:paypal-icon" />}
          sx={{ textTransform: "none", fontWeight: 500 }}
        >
          Payer par PayPal
        </Button>

        {/* Bouton Annuler */}
        <Button onClick={onClose} sx={{ textTransform: "none" }}>
          Annuler
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentDialog;
